// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Menu: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34">
            <g fill="none" fillRule="evenodd">
                <rect width="34" height="34" rx="2" />
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="M26.107 23.701H7.852c-.56 0-1.052.533-1.052 1.139 0 .694.492 1.227 1.052 1.227h18.255c.601 0 1.093-.533 1.093-1.139 0-.694-.492-1.227-1.093-1.227Zm0-15.768H7.852c-.56 0-1.052.533-1.052 1.139s.492 1.227 1.052 1.227h18.255c.601 0 1.093-.533 1.093-1.139s-.492-1.227-1.093-1.227Zm0 7.884H7.852c-.56 0-1.052.533-1.052 1.183s.492 1.183 1.052 1.183h18.255c.601 0 1.093-.533 1.093-1.183s-.492-1.183-1.093-1.183Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(Menu);
